import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  margin-top: -30px;
  scroll-margin-top: 400px;
`

export const Content = styled.div`
  height: 100%;
  width: 100%;
  max-width: 1440px;
  padding: 0 0 30px;
  scroll-margin-top: 400px;

  .gsc-webResult.gsc-result,
  .gsc-control-cse {
    background-color: ${({ theme }) => theme.colors.lightGrey};
    border-color: ${({ theme }) => theme.colors.lightGrey};
    padding: 10px 0;
  }
  .gsc-control-cse {
    scroll-margin-top: 200px;
  }
  .gsc-results-wrapper-nooverlay .gsc-results-wrapper-visible {
    scroll-margin-top: 400px;
  }
  .gsc-adBlock {
    display: none;
  }
  .gsc-results .gsc-cursor-box .gsc-cursor-current-page {
    background-color: ${({ theme }) => theme.colors.lightGrey};
  }
  .gsc-cursor-page {
    background-color: ${({ theme }) => theme.colors.lightGrey} !important;
    margin-right: 20px !important;
  }
`

export const Title = styled.div`
  font-size: 28px;
`
